<style scoped lang="scss">
    @media print
    {
        .no-print, .no-print *
        {
            display: none !important;
        }
        .uk-width-medium-5-10
        {
            width:50% !important;
        }
    }
</style>

<template>
    <div class="uk-container">
        <div class="uk-grid ">

            <div class="uk-width-1-1 uk-margin-large">
                <h1><i class="uk-icon-truck"></i> Mail Mainfest For {{ applicant.first_name }} {{ applicant.last_name }}</h1>
                <h3 class="uk-margin-top-remove"><i class="uk-icon-copy"></i>  Application ID: #{{ application.id }}</h3>
            </div>
            <div class="uk-width-1-1 uk-margin-large-bottom">

                <div class="uk-panel-box uk-panel-box-secondary"><i class="uk-icon-exclamation-circle uk-icon-large uk-margin-right"></i> <strong>YOU MUST INCLUDE A COPY OF THIS MANIFEST WITH YOUR DOCUMENTS, OTHERWISE YOUR APPLICATION PROCESSING MAY BE DELAYED.</strong></div>

            </div>



            <div class="uk-width-2-5">ATTN: {{application.program.agency_name}}</div>
            <div class="uk-width-3-5"></div>
            <div class="uk-width-1-1"><hr class="uk-grid-divider uk-margin-top-remove"></div>

            <div class="uk-width-1-1">Date: {{ dateString }}</div>
            <div class="uk-width-1-1"><hr class="uk-grid-divider uk-margin-top-remove"></div>

            <div class="uk-width-2-5">MAIL TO: </div>
            <div class="uk-width-3-5">
                {{application.program.agency_name}}<br/>
               {{application.program.street}}<br />
                {{application.program.city}}, {{application.program.state}} {{application.program.zip}}

            </div>
            <div class="uk-width-1-1"><hr class="uk-grid-divider uk-margin-top-remove"></div>

            <div class="uk-width-2-5">Number of documents: {{requests.length }}</div>
            <div class="uk-width-3-5"></div>
            <div class="uk-width-1-1">
                <hr class="uk-grid-divider uk-margin-top-remove">
            </div>

            <div class="uk-width-1-1 ">


                <p>I have attached the following documents:</p>
                <div class="uk-grid uk-grid-width-1-2">
                    <ul class="uk-margin-left">
                        <li v-for="request in requests">
                            {{ request.category.document_category_name }} - {{ request.household_member.first_name }} {{ request.household_member.last_name }}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="uk-width-1-1"><hr class="uk-grid-divider uk-margin-large-top"></div>

            <div class="uk-width-2-5">FROM:</div>
            <div class="uk-width-3-5">
                {{ applicant.first_name }} {{ applicant.last_name }}
                <br/>
                {{ applicant.email }}
            </div>
            <div class="uk-width-1-1">
                <hr class="uk-grid-divider uk-margin-large-top">
            </div>

            <div class="uk-width-2-5">APPLICANT ADDRESS:</div>
            <div class="uk-width-3-5">
                {{ applicant.property_address.line_1 }}
                <br/>
                {{ applicant.property_address.city }}, {{ applicant.property_address.state }} {{ applicant.property_address.zip }}
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "SnailMailManifest",
        props: ['application', 'requests', 'applicant'],
        data() {
            return {
                dateString: moment().format('MM/DD/YYYY h:m a')
            }
        }
    }
</script>
